import { render, staticRenderFns } from "./CustomerList079.vue?vue&type=template&id=cee816da"
import script from "./CustomerList079.vue?vue&type=script&lang=js"
export * from "./CustomerList079.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports